export const siteInfo = {
  name: "爆料在线",
  slogan: "别人看到热闹，我们看清门道",
  intro:
    "专注独家内容的爆料资讯门户，持续输出首发猛料、内幕消息与独家调查。以微八卦的视角深挖细节，给你别处看不到的深度解读。",
  email: "contact@baoliao-online.example.com",
  tipEmail: "tips@baoliao-online.example.com",
  since: "2021",
  stats: [
    { value: "730+", label: "累计独家首发" },
    { value: "86", label: "深度调查报道" },
    { value: "42 万", label: "邮件订阅读者" },
    { value: "98%", label: "信息可追溯率" },
  ],
  principles: [
    {
      icon: "ri-shield-check-line",
      title: "先核实，后发布",
      desc: "任何独家内容进入发布队列前，都必须完成来源登记与交叉验证，宁慢一步，不错一句。",
    },
    {
      icon: "ri-links-line",
      title: "标注信息链路",
      desc: "我们公开信息的时间节点与来源类型，让读者可以自行判断可信度，而不是只能选择相信。",
    },
    {
      icon: "ri-refresh-line",
      title: "有错就改，留痕更正",
      desc: "出现新的反证时，我们在原文公开更新并保留修改记录，不做无声无息的删改。",
    },
    {
      icon: "ri-user-heart-line",
      title: "不消费私人生活",
      desc: "报道聚焦公开可核事实与行业逻辑，明确区分事实与推测，克制使用未经证实的私人信息。",
    },
  ],
  timeline: [
    { year: "2021", text: "从几条深夜的独家快讯起步，确立「先核实后发布」的基本准则。" },
    { year: "2023", text: "上线内幕调查栏目，把单条爆料升级为完整的时间线复盘。" },
    { year: "2025", text: "微八卦栏目与深度长文成型，形成快讯、解读、调查三层内容结构。" },
    { year: "2026", text: "邮件订阅读者突破四十万，开始尝试把爆料整理成可检索的资料库。" },
  ],
  voices: [
    {
      name: "郑一鸣",
      role: "从业十年的制片人",
      text: "他们问的问题很具体，不满足于「听说」。被这样的记者追问过，反而会更愿意把话说清楚。",
    },
    {
      name: "梁思齐",
      role: "长期读者",
      text: "看爆料最怕被带节奏。这里会把哪些是事实、哪些是推测分开写，这点很难得。",
    },
    {
      name: "何知远",
      role: "媒体观察者",
      text: "在信息速度优先的环境里，愿意为一个结论多等两周的团队不多了。",
    },
  ],
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "独家猛料", to: "/category/exclusive" },
  { label: "内幕调查", to: "/category/investigation" },
  { label: "微八卦", to: "/category/gossip" },
  { label: "首发快讯", to: "/category/flash" },
  { label: "关于我们", to: "/about" },
];

export const tickerItems = [
  "独家：沈星野新约谈判进入第四轮，剪辑权归属成核心分歧",
  "《雾港》停摆四十天后改档十月，承制与平台结算机制受关注",
  "《山海拾遗》官宣开机，主创名单与取景地同步公开",
  "周叙白新片预算翻倍，制作周期延长至一百零五天",
  "短剧行业获客成本上涨，爆款生命周期压缩至不足一周",
  "《长夜未明》补拍结局，上线时间顺延约两周",
  "白鹿鸣工作室试点 AI 剪辑助手，三个月后评估",
];